import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICaseFile } from '../../../interfaces/case-file.interface';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { ModalFileShowViewComponent } from 'src/app/components/shared/components/modal-file-show-view/modal-file-show-view.component';
@Component({
  selector: 'case-file-item',
  templateUrl: './case-file-item.component.html',
  styleUrls: ['./case-file-item.component.scss'],
})
export class CaseFileItemComponent implements OnInit {
  @Input() file: ICaseFile;
  @Output() deleteFile = new EventEmitter<string>();

  constructor(
      private readonly dialog: MatDialog
    ) {}

  ngOnInit() {}

  get date() {
    return moment(this.file.createdAt || new Date()).format(
      'd/MM/yyyy h:mm a	 HH:mm'
    );
  }

  download() {
    const path = this.file.url + `?name=${this.file.name}&download=true`;
    var a = document.createElement('a');
    a.href = path;
    a.download = path.substr(path.lastIndexOf('/') + 1);
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  delete() {
    this.deleteFile.emit(this.file.url);
  }
  view() {
          this.dialog
            .open(ModalFileShowViewComponent, {
              data: this.file,
              minWidth: '1%',
            })
            .afterClosed()
            .subscribe(async (re) => {});
    }
}
// http://localhost:3100/v1/Sun Mar 05 2023 13:34:10 GMT-0400 (hora de Venezuela)/files/get/x.docx?name=x.docx&download=true
